export type TypeaheadBlurAction = 'clear' | 'revert' | 'noop' | 'keep';

/** What a single-value typeahead field should do on blur when no suggestion was picked. */
export const resolveTypeaheadBlurAction = (
  typedValue: string,
  committedLabel: string,
  options?: { keepsTypedText?: boolean },
): TypeaheadBlurAction => {
  if (options?.keepsTypedText) {
    // Kept text is saved trimmed, so blank text clears and spacing alone is no change.
    const typed = typedValue.trim();
    if (typed === '') return 'clear';
    return typed === committedLabel.trim() ? 'noop' : 'keep';
  }
  if (typedValue === committedLabel) return 'noop';
  return typedValue === '' ? 'clear' : 'revert';
};
